import Experience from "./Experience";


export default function ProfileTabs(){
    return(

      <Experience/>

    )
}